import { useState, useEffect } from 'react';

const getSessionData = () => {
  return JSON.parse(sessionStorage.getItem('accessToken'))
}

const useSession = () => {
  const [session, setSession] = useState(getSessionData());
  useEffect(() => {
    const handleChangeStorage = () => {
      setSession(getSessionData())
    }

    window.addEventListener('storage', handleChangeStorage())
    return () => window.removeEventListener('storage', handleChangeStorage())
  }, []);
  return session;
}
 
export default useSession;